var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoodAfternoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1783",
    "data-name": "Rectangle 1783",
    width: 40,
    height: 40,
    transform: "translate(-21551 -17133)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_47",
    "data-name": "Mask Group 47",
    transform: "translate(21551 17133)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clouds-and-sun",
    transform: "translate(-21551 -17133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9841",
    "data-name": "Path 9841",
    d: "M34.971,33.094A19.559,19.559,0,1,1,39.79,17.126a8.928,8.928,0,0,0-1.635,5.15V28.3q-.385.82-.842,1.6l-.565.289A3.263,3.263,0,0,0,34.971,33.094Z",
    fill: "#3493f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9842",
    "data-name": "Path 9842",
    d: "M36.743,20.943A15.586,15.586,0,1,1,21.156,5.356,15.586,15.586,0,0,1,36.743,20.943Z",
    fill: "#55a4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9843",
    "data-name": "Path 9843",
    d: "M35.13,8.743a1.2,1.2,0,0,1-1.2,1.2H25.948a1.2,1.2,0,0,1,0-2.4h7.984A1.2,1.2,0,0,1,35.13,8.743ZM21.956,33.094H13.972a1.2,1.2,0,1,0,0,2.4h7.984a1.2,1.2,0,1,0,0-2.4ZM9.2,17.585H5.207a1.2,1.2,0,1,0,0,2.4H9.2a1.2,1.2,0,0,0,0-2.4Z",
    fill: "#86befb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9844",
    "data-name": "Path 9844",
    d: "M19.216,3.158l2.643,5.38a.4.4,0,0,0,.6.14l7.56-5.819a.4.4,0,0,1,.62.45l-3.216,9.039a.4.4,0,0,0,.275.52l5.193,1.365a.4.4,0,0,1,.187.662l-3.487,3.642a.4.4,0,0,0,.063.605l7.885,5.4a.4.4,0,0,1-.237.728l-9.572-.265a.4.4,0,0,0-.408.438l.563,5.777a.4.4,0,0,1-.588.39l-4.791-2.6a.4.4,0,0,0-.573.238L19.24,38.4a.4.4,0,0,1-.766,0l-2.7-9.151a.4.4,0,0,0-.569-.24L10.27,31.614a.4.4,0,0,1-.583-.4l.693-5.759a.4.4,0,0,0-.407-.447l-9.562.265a.4.4,0,0,1-.237-.728L8,19.182a.4.4,0,0,0,.023-.642L1.7,13.514a.4.4,0,0,1,.246-.712l7.925-.042a.4.4,0,0,0,.374-.533L7.074,3.309a.4.4,0,0,1,.62-.45l7.56,5.819a.4.4,0,0,0,.6-.14L18.5,3.158a.4.4,0,0,1,.717,0Z",
    fill: "#ffa90b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9845",
    "data-name": "Path 9845",
    d: "M33.079,14.9l-3.487,3.642a.4.4,0,0,0,.063.605l1.085.743A19.788,19.788,0,0,1,28.609,20,19.567,19.567,0,0,1,9.405,4.177l5.849,4.5a.4.4,0,0,0,.6-.14L18.5,3.158a.4.4,0,0,1,.717,0l2.643,5.38a.4.4,0,0,0,.6.14l7.56-5.819a.4.4,0,0,1,.62.45l-3.216,9.039a.4.4,0,0,0,.275.52l5.193,1.365a.4.4,0,0,1,.187.662Z",
    fill: "#ffc14f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9846",
    "data-name": "Path 9846",
    d: "M28.039,18.876a9.182,9.182,0,1,1-9.182-9.182A9.182,9.182,0,0,1,28.039,18.876Z",
    fill: "#fff36c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9847",
    "data-name": "Path 9847",
    d: "M28.039,18.876a9.141,9.141,0,0,1-1.145,4.444,9.184,9.184,0,0,1-12.48-12.48,9.184,9.184,0,0,1,13.625,8.037Z",
    fill: "#fff68e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9848",
    "data-name": "Path 9848",
    d: "M31.138,29.9h6.175a19.628,19.628,0,0,1-2.342,3.194H31.138a1.6,1.6,0,0,1,0-3.194ZM39.79,17.126H21.557a1.6,1.6,0,0,0,0,3.194h3.992a1.6,1.6,0,1,1,0,3.194H14.371a1.6,1.6,0,1,0,0,3.194H34.818a5.086,5.086,0,0,0,5.06-4.509,19.819,19.819,0,0,0-.088-5.072Z",
    fill: "#fff5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9849",
    "data-name": "Path 9849",
    d: "M38.155,28.3H26.347a1.6,1.6,0,0,1,0-3.194h5.589a1.6,1.6,0,0,0,1.6-1.6,1.6,1.6,0,0,1,1.6-1.6h4.778A19.434,19.434,0,0,1,38.155,28.3Z",
    fill: "#a7d0fc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodAfternoon);
export default __webpack_public_path__ + "static/media/good-afternoon.9644eb9d043727e4d9aa19f6126db7aa.svg";
export { ForwardRef as ReactComponent };